import { DevicesList } from "../constants/devices-list.constant";

export default class SsoModalService {
    static makeAccountList(products, userPreference) {
        const devicesList = this.fetchDevicesList(userPreference);
        const accountList = this.fetchAccountList(products, devicesList);
        return accountList;
    }

    static fetchDevicesList(userPreference) {
        return DevicesList[userPreference];
    }

    static fetchAccountList(products, devicesList) {
        const accountList = [];
        if(products) {
            for(let product in products){
                if(devicesList) {	
                    for(let device in devicesList) {
                        if(devicesList[device]===product){
                            const productList = products[product];
                            if(productList) {
                                productList.forEach(productItem => {
                                    accountList.push({
                                        "siNumber": productItem.siNumber,
                                        "lob": productItem.lob,
                                        "circleName": productItem.circleName,
                                        "accountNumber": productItem.accountNumber ? productItem.accountNumber: ""
                                    })
                                });
                            }
                            else {
                                continue;
                            }
                        }
                    }
                }
            }
        }
        return accountList;
    }
}